import { createSelector } from 'reselect';

export const authSelector = state => state.auth;

export const getEmail = createSelector(authSelector, auth => auth.email);
export const getAuthenticated = createSelector(
  authSelector,
  auth => auth.authenticated,
);

// TODO 修正する
export function isDemo(email) {
  return process.env.REACT_APP_ENV === 'development'
    ? false
    : email === 'demo@nazotoki-bingo.com';
}



// WEBPACK FOOTER //
// ./src/core/auth/selectors.js